var map = {
	"./CBF.jpg": "emI0",
	"./CPR.png": "46YZ",
	"./OFCO-logo.png": "f5Rv",
	"./container-img.jpg": "U74F",
	"./css/dfyuanstd-w3.otf": "c5Af",
	"./css/dfyuanstd-w5.otf": "mpnd",
	"./css/dfyuanstd-w7.otf": "MROa",
	"./css/dfyuanstd-w8.otf": "0Kps",
	"./eboard-factory-new.png": "Clwl",
	"./eboard-factory-new_org.png": "6aeu",
	"./eboard-factory1.png": "6YSH",
	"./eboard-factory1_org.png": "xyUK",
	"./eboard-factory2.png": "GrNn",
	"./heat-treatment-model.jpg": "EUoe",
	"./heat-treatment.png": "g+Gj",
	"./heat-treatment2.png": "r/eo",
	"./heat-treatmentA.png": "HC0w",
	"./heat-treatmentB.png": "7vlT",
	"./heat-treatmentC.png": "GYPQ",
	"./heat-treatmentD.png": "CVsL",
	"./heat-treatmentD2.png": "YVM+",
	"./heat-treatmentE.png": "/HKS",
	"./kimaker_logo.png": "EBXF",
	"./light-blue.png": "Ar4C",
	"./light-gray.png": "fjUl",
	"./light-green.png": "ETZJ",
	"./light-orange.png": "SLyu",
	"./light-red.png": "clzG",
	"./light-white.png": "c9BV",
	"./light-yellow.png": "t4Km",
	"./logo.png": "7Otq",
	"./package-img.png": "6CIc",
	"./package.png": "M0Mm",
	"./photo-test01.jpg": "7EMZ",
	"./photo-test02.jpg": "INIX",
	"./sapidoLOGO.png": "sZ4v",
	"./sapidoLOGOw.png": "PSee",
	"./zoom-in.png": "5iLG",
	"./一般通知.png": "EtCQ",
	"./包裝-洪詩儀.jpg": "e2ey",
	"./包裝第一組組長-陳文選.jpg": "/f1c",
	"./包裝第七組組長-張子浩.jpg": "6bfP",
	"./包裝第三組組長-李美敏.jpg": "qku8",
	"./包裝第二組組長-王煦妍.jpg": "NG+0",
	"./包裝第五組組長-陳維新.jpg": "EEyz",
	"./包裝第十組組長-陳美玲.jpg": "4ClO",
	"./包裝第四組組長-陳進茂.jpg": "XO96",
	"./成一-于志明.jpg": "DUJT",
	"./成一-陳晉華.jpg": "S/n7",
	"./成二-廖進吉.jpg": "ZxnA",
	"./成二-邱連城.jpg": "owMG",
	"./成五-孫震宇.jpg": "JyHk",
	"./成五-蔡坤益.jpg": "aHVJ",
	"./成五-顏勝一.jpg": "tQSM",
	"./成四-廖進吉.jpg": "HmaX",
	"./成四-張文吉.jpg": "VNfj",
	"./早班組長-李佳壕.jpg": "bwSh",
	"./早班領班-桃青龍.jpg": "phrj",
	"./晚班組長-蔣文財.png": "9cNc",
	"./晚班領班-潘宏典.png": "Hxwq",
	"./晚班領班-王偉豊.png": "mtpp",
	"./裝櫃-黃泓浩.jpeg": "gM1C",
	"./裝櫃-黃順雨.jpeg": "pevV",
	"./課長-張靖彬.png": "Dm9u",
	"./輾一-黃志華.jpg": "+ajT",
	"./輾二-張宗賢.jpg": "cP7I",
	"./輾二-賴培銘.jpg": "xUAt",
	"./輾二-陳冠羽.jpg": "3MsC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1